import ChevronIcon from "@/common/images/icons/chevron.svg?react";
import { Link } from "react-router-dom";
import "./Breadcrumbs.scss";

interface IBreadcrumb {
  title: string;
  link?: string;
}

interface IBreadcrumbsProps {
  items: IBreadcrumb[];
}

export const Breadcrumbs = ({ items }: IBreadcrumbsProps) => {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;

        return (
          <div key={idx} className="breadcrumbsSegment">
            {!isLast && item.link ? (
              <>
                <Link className="breadcrumbsItem" to={item.link}>
                  {item.title}
                </Link>
                <ChevronIcon className="chevronIcon" />
              </>
            ) : (
              <span className="breadcrumbsItem breadcrumbsItemActive">
                {item.title}
              </span>
            )}
          </div>
        );
      })}
    </nav>
  );
};
